module.exports = __webpack_public_path__ + "img/btn.a14fb60d.png";